import React from "react";
import ImageViewer from 'react-simple-image-viewer';

const initialState = {
  imageFiles: [],
  isOpen: false,
  current: 0,
};

const ImagePreview = ({ images }) => {
  const [{ current, isOpen, imageFiles }, setState] =
    React.useState(initialState);

  const openImageViewer = React.useCallback((index) => {
    setState((prevState) => ({ ...prevState, current: index, isOpen: true }));
  }, []);

  const closeImageViewer = () => {
    setState((prevState) => ({ ...prevState, current: 0, isOpen: false }));
  };

  React.useEffect(() => {
    if (images) {
      let im = [];

      images?.forEach((d) => {
        const payload = d?.replace('_thumb', '');
        im?.push(payload);
      });

      setState((prevState) => ({ ...prevState, imageFiles: im }));
    }
  }, [images]);

  return (
    <>
      <div className="row align-items-center justify-content-center ">
        {images?.map((d, i) => (
          <div
            key={i}
            className="position-relative col-4"
            style={{ height: 100, width: 100, margin: 5 }}
          >
            <img
              src={d}
              alt=""
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
                borderRadius: 5,
              }}
              onClick={() => openImageViewer(i)}
            />
          </div>
        ))}
      </div>


      {isOpen && (
        <ImageViewer
          src={imageFiles}
          currentIndex={current}
          onClose={closeImageViewer}
          disableScroll={false}
          backgroundStyle={{
            backgroundColor: 'rgba(0,0,0,0.9)',
          }}
          closeOnClickOutside={true}
        />
      )}
    </>

  )
};

export default ImagePreview;